import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  breakpoint: {
    thresholds: {
      // TODO: Uncomment and make scss file if required.
      // xs: 730,
      // sm: 800,
      // md: 960,
      // lg: 1264,
      // xl: 1904
    },
  },
})
